import moment from 'moment';

// Keeps only digits and inserts the slash: "1020" -> "10/20", "102026" -> "10/2026".
export var maskMonthInput = function(raw) {
  var digits = String(raw || '').replace(/\D/g, '').slice(0, 6);
  if (digits.length <= 2) return digits;
  return digits.slice(0, 2) + '/' + digits.slice(2);
};

// Parses what the user typed into a moment at the start of the month, or null.
// Accepts "10/2026", "1/2026", "10-2026", "102026" and two-digit years ("10/26").
export var parseMonthInput = function(text) {
  var value = String(text || '').trim();
  if (!value) return null;

  var match = value.match(/^(\d{1,2})\s*[/.-]\s*(\d{2}|\d{4})$/) || value.match(/^(\d{2})(\d{4})$/);
  if (!match) return null;

  var month = parseInt(match[1], 10);
  var year = parseInt(match[2], 10);
  if (match[2].length === 2) year += 2000;
  if (month < 1 || month > 12 || year < 1900 || year > 2100) return null;

  return moment({ year: year, month: month - 1, day: 1 });
};
